import React, {useMemo} from 'react';

import {Box} from '@mui/material';
import {useAutoField} from '../../components/AutoForm/useAutoForm';
import {RiskProfileFragment} from '../../schema-types/RiskProfileFragment';
import {riskNotesFormType} from './riskNotesFields';
import {useOnUpdate} from '../../hooks/useOnUpdate';
import {Prompt} from '../../components/Prompt/Prompt';
import {RichEditor} from '../../components/RichEditor/RichEditor';
import {UPDATES} from '../../shared/UPDATES';

export const useRiskNotesNoChanges = () => {
  const [{value: KNOWLEDGE_AND_BEHAVIOUR_NO_CHANGE}] = useAutoField<
    riskNotesFormType['KNOWLEDGE_AND_BEHAVIOUR']
  >('KNOWLEDGE_AND_BEHAVIOUR.noChange');
  const [{value: VALUES_AND_SERVICE_NO_CHANGE}] = useAutoField<
    riskNotesFormType['VALUES_AND_SERVICE']
  >('VALUES_AND_SERVICE.noChange');
  const [{value: FINANCIAL_CAPACITY_NO_CHANGE}] = useAutoField<
    riskNotesFormType['FINANCIAL_CAPACITY']
  >('FINANCIAL_CAPACITY.noChange');

  const allNoChanges = useMemo(() => {
    if (
      KNOWLEDGE_AND_BEHAVIOUR_NO_CHANGE &&
      VALUES_AND_SERVICE_NO_CHANGE &&
      FINANCIAL_CAPACITY_NO_CHANGE
    ) {
      return true;
    }
    return false;
  }, [
    KNOWLEDGE_AND_BEHAVIOUR_NO_CHANGE,
    VALUES_AND_SERVICE_NO_CHANGE,
    FINANCIAL_CAPACITY_NO_CHANGE,
  ]);

  return {allNoChanges};
};

export const RiskNotesNoChange: React.FC<{
  onChange: (val: Partial<RiskProfileFragment>) => void;
}> = ({onChange}) => {
  const [{value: noteValue}, _, {setValue: setNoteValue}] = useAutoField<
    riskNotesFormType['noChangeReasonNotes'] | undefined
  >(`noChangeReasonNotes`);

  useOnUpdate(() => {
    if (noteValue) {
      onChange({noChangeReasonNotes: noteValue});
    }
  }, [noteValue]);

  return (
    <Prompt
      content={
        <>
          <Box mt={2} />
          <RichEditor
            formikId="noChangeReasonNotes"
            placeholder="Please provide a reason for no changes"
            onSave={async (val) => {
              setNoteValue(UPDATES._1000, val);
            }}
            charLimit={5000}
            initialValue={noteValue}
          />
        </>
      }
      title="You have selected no change for all sections, please provide a reason"
      variant="error"
    />
  );
};
